import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import mobile from 'is-mobile';

export const MobileRoute: React.FC = () => {
  return !mobile() ? <Outlet /> : <Navigate to={'mobile' + window.location.pathname} />;
};
